import { useCallback, useEffect } from 'react'
import * as React from 'react'

export const useKeyboardNavigation = (
  ref: React.RefObject<HTMLDivElement>,
  opts: { onNavigate: () => void } = { onNavigate: () => null },
) => {
  const focusElement = useCallback(
    (focusInt: any) => {
      //add all elements we want to include in our selection
      const focussableElements =
        'a:not([disabled]), button:not([tabindex="-1"]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'

      if (ref.current) {
        const focussable = Array.prototype.filter.call(
          ref.current.querySelectorAll(focussableElements),
          function (element) {
            //check for visibility while always include the current activeElement
            return element.offsetWidth > 0 || element.offsetHeight > 0
          },
        )

        const index = focussable.indexOf(document.activeElement)

        const nextElement = focussable[index + focusInt] || focussable[0]
        if (nextElement) nextElement.focus()
      }
    },
    [ref],
  )

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'ArrowUp' || (event.key === 'Tab' && event.shiftKey)) {
        event.preventDefault()
        opts?.onNavigate()
        return focusElement(-1)
      }

      if (event.key === 'ArrowDown' || event.key === 'Tab') {
        event.preventDefault()
        opts?.onNavigate()
        return focusElement(1)
      }
    },
    [focusElement, opts],
  )

  useEffect(() => {
    focusElement(1)
  }, [focusElement, ref])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
